import styled from "styled-components";
import InputMask from "react-input-mask";

const InputTimeField = styled(InputMask)`
    width: 100%;
    height: 32px;
    font-size: 16px;
    text-align: left;
    margin-right: 8px;
    border-radius: 4px;
    border: 1px solid #ccc;
    outline: none;

    font-family: "Source Sans Pro", sans-serif;
    height: 48px;
    box-sizing: border-box;
    font-size: 1rem;
    color: rgb(73, 80, 87);
    appearance: none;
    border-radius: 4px;
    border: 1px solid rgb(120, 120, 120) !important;
    padding: 0.5rem 0.75rem;
`;

export default InputTimeField;
